import { Home, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CALENDLY_MOBILE } from '../constants/calendly';
import { useCalendlyEmbed } from '../context/CalendlyEmbedContext';
import SafeImage from './SafeImage';
import './MobileTraining.css';

function MobileTraining({ data = {} }) {
  const { openCalendly } = useCalendlyEmbed();
  const defaultData = {
    title: 'Anywhere, Anytime',
    subtitle: 'We Come To You',
    description: 'Experience the ultimate convenience with our mobile personal training service. Your personal trainer comes directly to your home, office, or preferred location. No commute, no crowded gyms - just personalized attention in the comfort of your own space.',
    imageUrl: '',
    features: [
      'Train in the comfort of your home',
      'Flexible scheduling around your life',
      'No gym membership required',
      'All equipment provided',
      'Private one-on-one attention'
    ]
  };

  const displayData = Object.keys(data).length > 0 ? data : defaultData;

  return (
    <section className="mobile-training-section" id="mobile-training">
      <div className="mobile-training-container">
        <div className="mobile-training-content">
          <div className="mobile-training-text">
            <div className="section-header">
              <h2 className="section-title">{displayData.title}</h2>
              <p className="section-subtitle">{displayData.subtitle}</p>
            </div>

            <p className="mobile-description">{displayData.description}</p>

            <div className="mobile-features">
              {(displayData.features || defaultData.features).map((feature, index) => (
                <div key={index} className="mobile-feature-item">
                  <CheckCircle size={20} />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
              <button
                type="button"
                onClick={() => openCalendly(CALENDLY_MOBILE)}
                className="mobile-cta-button"
              >
                <Home size={20} />
                <span>Book Mobile Training</span>
              </button>
              
              <Link 
                to="/mobile"
                className="mobile-cta-button secondary"
                style={{textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem'}}
              >
                Learn More
              </Link>
            </div>
          </div>

          <div className="mobile-training-image">
            {displayData.imageUrl ? (
              <SafeImage src={displayData.imageUrl} alt={displayData.title} />
            ) : (
              <div className="image-placeholder">
                <Home size={100} />
                <p>Upload an image in Admin Panel</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default MobileTraining;
